import PropTypes from 'prop-types'
import React from 'react'
import logo from '../images/logo-white_transparent.png'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <img src={logo} alt="Logo" style={{height: '100%'}} />
    </div>
    <div className="content">
      <div className="inner">
        <h1>Medeed</h1>
        <h2>Professionals in Healthcare</h2>
        <p>
          Werden Sie schon jetzt Teil des modernsten Jobnetzwerks im medizinischen Bereich!
        </p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('about')
            }}
          >
            About
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            Kontakt
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('work')
            }}
          >
            Impressum
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
